var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 13,
  viewBox: "0 0 18 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7071 0.292893C18.0976 0.683417 18.0976 1.31658 17.7071 1.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071L0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289C0.683417 5.90237 1.31658 5.90237 1.70711 6.29289L6 10.5858L16.2929 0.292893C16.6834 -0.0976311 17.3166 -0.0976311 17.7071 0.292893Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjcwNzEgMC4yOTI4OTNDMTguMDk3NiAwLjY4MzQxNyAxOC4wOTc2IDEuMzE2NTggMTcuNzA3MSAxLjcwNzExTDYuNzA3MTEgMTIuNzA3MUM2LjMxNjU4IDEzLjA5NzYgNS42ODM0MiAxMy4wOTc2IDUuMjkyODkgMTIuNzA3MUwwLjI5Mjg5MyA3LjcwNzExQy0wLjA5NzYzMTEgNy4zMTY1OCAtMC4wOTc2MzExIDYuNjgzNDIgMC4yOTI4OTMgNi4yOTI4OUMwLjY4MzQxNyA1LjkwMjM3IDEuMzE2NTggNS45MDIzNyAxLjcwNzExIDYuMjkyODlMNiAxMC41ODU4TDE2LjI5MjkgMC4yOTI4OTNDMTYuNjgzNCAtMC4wOTc2MzExIDE3LjMxNjYgLTAuMDk3NjMxMSAxNy43MDcxIDAuMjkyODkzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";